import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { useTheme } from '../contexts/ThemeContext';

export const setupStatusBar = async () => {
  if (Capacitor.getPlatform() === 'ios') {
    try {
      // Set transparent background
      await StatusBar.setBackgroundColor({ color: '#00000000' });
      // Show the status bar
      await StatusBar.show();
    } catch (error) {
      console.error('Error setting up status bar:', error);
    }
  }
};

export const updateStatusBarStyle = (isDarkMode: boolean) => {
  if (Capacitor.getPlatform() === 'ios') {
    StatusBar.setStyle({ 
      style: isDarkMode ? Style.Dark : Style.Light 
    });
  }
};
